import { render, staticRenderFns } from "./Preapprovals.vue?vue&type=template&id=d35d5434&scoped=true&"
import script from "./Preapprovals.vue?vue&type=script&lang=js&"
export * from "./Preapprovals.vue?vue&type=script&lang=js&"
import style0 from "./Preapprovals.vue?vue&type=style&index=0&id=d35d5434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35d5434",
  null
  
)

export default component.exports